import { cs2Constants } from '../_constants';

export function cs2Submission(state = {}, action) {
	
	console.log("action.type: " + action.type);
    switch (action.type) {
        case cs2Constants.EXECUTIONS_REQUEST:
            return {
				loading: true,
				summary: { "nyseStocks": 0, "nyseDollars": 0, "nyseShares": 0, "amexStocks" : 0, "amexDollars": 0, "amexShares" : 0, "acceptedCount" : 0, "rejectedCount" : 0 }
            };
        case cs2Constants.EXECUTIONS_SUCCESS:
			const summary = action.executions.result.reduce( (accumulator, basket) => {
				if (basket.accepted == 'Y') {
					accumulator.nyseStocks += Number(basket.nyseStocks);
					accumulator.nyseDollars += Number(basket.nyseDollars);
					accumulator.nyseShares += Number(basket.nyseShares);
					accumulator.amexStocks += Number(basket.amexStocks);
					accumulator.amexDollars += Number(basket.amexDollars);
					accumulator.amexShares += Number(basket.amexShares);
					accumulator.acceptedCount += 1;
				} else {
					accumulator.rejectedCount += 1;
				}
				return accumulator;

				}, 
				// this is default values, which accumulator will use for the first and start accumulating the results. 
				{ "nyseStocks": 0, "nyseDollars": 0, "nyseShares": 0, "amexStocks": 0, "amexDollars": 0, "amexShares": 0, "acceptedCount": 0, "rejectedCount": 0})


				return {
					//items: JSON.stringify(action.executions.result)
					items: action.executions.result,
					summary: summary
				};
        case cs2Constants.EXECUTIONS_FAILURE:
            return {
                error: action.error,
				summary: { "nyseStocks": 0, "nyseDollars": 0, "nyseShares": 0, "amexStocks" : 0, "amexDollars": 0, "amexShares" : 0, "acceptedCount" : 0, "rejectedCount" : 0 }						 
            };

     	default:
            return state
    }
}